const AWS_STATIC_FILES = {
  DISPUTE_FORM: 'https://s3.ap-south-1.amazonaws.com/cdn.zaggle.in/pdf/Dispute_Form.pdf',
  GRIEVANCE_POLICY: 'https://s3.ap-south-1.amazonaws.com/assets.zaggle.in/pdf/Customer%20Grievance%20Policy_Hindi.pdf',
  MOBIKWIK_BANNER_DESKTOP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/mbkw-offer-banner-mar.webp', // jpg
    ALT: '',
  },
  ZAGGLE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/zaggle-new-logo.png',
    ALT: 'Zaggle - Rewards and Recognition | Expense Management | Employee Benefits',
  },
  ZAGGLE_CARDS_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/logo/zaggle-cards-logo.svg',
    ALT: 'Zaggle - Rewards and Recognition | Expense Management | Employee Benefits',
  },
  MOBIKWIK_BANNER_MOBILE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/mbkw-offer-banner-mar-mobile.webp', // jpg
  },
  ONEMG_BANNER_DESKTOP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/1mg-desktop.webp', // jpg
    ALT: '',
  },
  ONEMG_BANNER_MOBILE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/1mg-mobile.webp', // jpg
    ALT: '',
  },
  SAVE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/save-logo.png',
    ALT: 'Save - Expense Management | Employee Tax Benefits',
  },
  SAVE_PLUS_LOGO: 'https://cdn.zaggle.in/images/web/save/save-home.png',
  PROPEL_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/propel/propel-logo-new.png',
    ALT: 'Propel - Employee Rewards and Recongnation | Cannel Incentives Program',
  },
  EDGE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/edge/edge-home.png',
    ALT: 'Edge - Corporate Gifting | Gift Cards ',
  },
  SELECT_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/select/select-home.png',
    ALT: 'Select - Customized Corporate Solutions',
  },
  HOME_CLIENTS_ONE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/brand-logos.webp', // jpg
    ALT: 'Trusted by 4000+ Brands Across the world',
  },
  HOME_CLIENTS_TWO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/logos-part2.webp', // png
    ALT: 'Trusted Brands - Zaggle ',
  },
  CORPORATE_GIFT_CARD: 'https://cdn.zaggle.in/images/web/common/corporate-gift-cards-bg.jpg',
  GIFT_MOBILE: 'https://cdn.zaggle.in/images/web/zaggle/webp/gifting-mobile.webp', // jpg
  SELECT_WALL: 'https://cdn.zaggle.in/images/web/zaggle/webp/select-bg.webp', // jpg
  SELECT_WALL_MOBILE: 'https://cdn.zaggle.in/images/web/zaggle/webp/select-mobile.webp', // png
  SELECT_DINING: 'https://cdn.zaggle.in/images/web/zaggle/webp/dining-img.webp', // png
  SELECT_BOOKING_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/common/booking_the_perfect.png',
    ALT: 'Corporate Group Dining, Curated Dininig - Special Projects',
  },
  SELECT_SAVING_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/select/great_saving.png',
    ALT: 'Corporate Cafeteria Solution, Cashless - Special Projects',
  },
  SELECT_PAYMENT_PROCESS_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/common/gain_more.png',
    ALT: 'Payment Solution, Business Operations, Payments Processing Solution - Special Projects',
  },
  SAVE_LANDING_DIWLAI_ONE: 'https://cdn.zaggle.in/images/web/edge/diwali-1.png',
  SAVE_LANDING_DIWLAI_RED: 'https://cdn.zaggle.in/images/web/edge/diwali-red-1.png',
  SAVE_LANDING_IMG: {
    URL: 'https://cdn.zaggle.in/images/web/edge/hysea-post.png',
    ALT: 'Best B2B Entreprise, Best Expense Management Solution, Zaggle Save',
  },
  SAVE_LANDING_BG: 'https://cdn.zaggle.in/images/web/edge/bg.png',
  SAVE_WALL: 'https://cdn.zaggle.in/images/web/save/landing-header.jpg',
  SAVE_WALL_MOBILE: 'https://cdn.zaggle.in/images/web/save/expense_management_mobile.jpg',
  SAVE_EXP_MANAGE: {
    URL: 'https://cdn.zaggle.in/images/web/save/old-school-vs-real-time.png',
    ALT: 'Traditional Expense Reporting, Expense Management Software',
  },
  SAVE_EXP_MANAGE_MOBILE: 'https://cdn.zaggle.in/images/web/common/expense-management-mobile.png',
  SAVE_CAPTURE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/capture.png',
    ALT: 'OCR Technology, Expense Reporting, Expense Management',
  },
  SAVE_AUTOMATE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/automate.png',
    ALT: 'Expense Reports - Expense Management',
  },
  SAVE_INSTANT_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/inst-ant.png',
    ALT: 'Budget Approval, Spend Visibility',
  },
  SAVE_CUTOFF_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/cut-off.png',
    ALT: 'Visibility & Control - Expense Management',
  },
  SAVE_CONTINOUS_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/continuous.png',
    ALT: 'Accounting Software, Software Integration',
  },
  SAVE_HASSLEFREE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/hassle-free.png',
    ALT: 'Hassle-Free, Expense Reimbursements',
  },
  SAVE_TRAVEL_EXPENSE: {
    URL: 'https://cdn.zaggle.in/images/web/common/travel-&-expense-management.png',
    ALT: 'Travel and Expense Management Software, Travel and Expense Management app, Travel and Expense Management System, Employee Travel Management',
  },
  SAVE_PREPAID_CARDS: {
    URL: 'https://cdn.zaggle.in/images/web/save/prepaid-cards-for-business-expenses.png',
    ALT: 'Prepaid Card, Expense Management, Multi Wallet Card',
  },
  SAVE_PRETTY_CASH: {
    URL: 'https://cdn.zaggle.in/images/web/save/petty-cash-management.png',
    ALT: 'Petty Cash Management, Petty Expenses, Petty Cash Expenses',
  },
  SAVE_EMP_EXP_REMBURSEMENT: {
    URL: 'https://cdn.zaggle.in/images/web/save/employee-expense-reimbursement.png',
    ALT: 'Expense Reporting, Submit Expenses on the go - Expense Management',
  },
  SAVE_EXPENSE_DASHBOARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/expense-management-dashboard.png',
    ALT: 'Expense Management Platform, Expense Management Sofware, Zaggle Dashboard',
  },
  SAVE_QUICK_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/quick-on.png',
    ALT: 'Easy Onboarding',
  },
  SAVE_ACCURATE_LOGO: 'https://cdn.zaggle.in/images/web/save/accurate.png',
  SAVE_ACCOUNT_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/setup-account.png',
    ALT: 'Customized Account Setup, Expense Spends',
  },
  SAVE_MANAGE_EXPENSE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/manage-expenses.png',
    ALT: 'Manage Expenses, Zaggle Dashboard',
  },
  SAVE_EMP_EMPLOYEE_BENEFITS_DASHBOARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/employee-benefits-dashboard-2.png',
    ALT: 'Cashless and Paperless, Employee Tax Benefits',
  },
  SAVE_EXPENSE_MANAGEMENT_DASHBOARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/expense-management-dashboard-1.png',
    ALT: ' Expense Management Platform, Visibility & Control - Expense Management',
  },
  SAVE_TIME: {
    URL: 'https://cdn.zaggle.in/images/web/save/time.png',
    ALT: 'Real Time Approval - Expense Management',
  },
  SAVE_SUPPORT: {
    URL: 'https://cdn.zaggle.in/images/web/save/support.png',
    ALT: 'Report Expenses - Expense Management',
  },
  SAVE_WORKER: {
    URL: 'https://cdn.zaggle.in/images/web/save/worker.png',
    ALT: 'Add Employees - Expense Management',
  },
  SAVE_CLICK: {
    URL: 'https://cdn.zaggle.in/images/web/save/click.png',
    ALT: 'One step signup - Expense Management',
  },
  SAVE_MIS_DASHBOARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/MIS-&-dashboard.png',
    ALT: 'Accounting Software Integration - Expense Management',
  },
  SAVE_LANDING_PAGE: {
    URL: 'https://cdn.zaggle.in/images/web/save/zaggle-Landing-page.png',
    ALT: 'Employee Expenses, Manage Expenses, Business Spends - Expense Management',
  },
  SAVE_GROUP_BANNER_IMAGE: 'https://cdn.zaggle.in/images/web/save/group-banner-image.png',
  SAVE_BACKGROUND_LINE: 'https://cdn.zaggle.in/images/web/save/background-line.png',
  SAVE_LANDINNGPAGE_BG: 'https://cdn.zaggle.in/images/web/save/landing-header-save-page.jpg',
  PROPEL_WALL: 'https://cdn.zaggle.in/images/web/propel/banner/employee-rewards-banner.jpg',
  PROPEL_WALL_MOBILE: 'https://cdn.zaggle.in/images/web/propel/banner/employee-rewards-recognisation-mobile.jpg',
  PROPEL_HAPINESS: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/happiness.png',
    ALT: 'Employee Rewards - Rewards and Recognition',
  },
  PROPEL_REWARDS: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/performance-rewards.png',
    ALT: 'Employee Motivation - Rewards and Recognition',
  },
  PROPEL_RETENTION: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/retention.png',
    ALT: 'Employee Retention - Rewards and Recognition',
  },
  PROPEL_PROFITABILITY: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/profitability.png',
    ALT: 'Employee Productivity - Rewards and Recognition',
  },
  PROPEL_P2P_REWARD: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/peer-to-peer-reward.png',
    ALT: 'Peer to Peer Rewards - Reward and Recognition',
  },
  PROPEL_PERFORMANCE_REWARD: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/performance-rewards2.png',
    ALT: 'Performance Rewards - Reward and Recognition',
  },
  PROPEL_PERSONAL_OCCASION: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/rewards-for-personal-occasions.png',
    ALT: 'Personal Occasional Rewards - Reward and Recognition',
  },
  PROPEL_WELLNESS_BENIFITS: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/employee-wellness-benefits.png',
    ALT: 'Employee Wellness, Wellness Benefits - Reward and Recognition.',
  },
  PROPEL_INCREASE_FOCUS: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/increase-focus.png',
    ALT: 'Cross Selling, Up Selling  - Rewards and Recognition',
  },
  PROPEL_ENHANCE_SALES: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/enhance-sales.png',
    ALT: 'Improve Performance - Rewards and Recognition',
  },
  PROPEL_ATTRACT_TALENT: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/attract-talent.png',
    ALT: 'Sales Growth - Rewards and Recognition',
  },
  PROPEL_DRIVE_MULTIPLE: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/drives-multiple.png',
    ALT: 'Achievements  - Rewards and Recognition',
  },
  PROPEL_DRIVE_LONGEVITY: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/drive-longevity.png',
    ALT: 'Employee Service - Rewards and Recognition',
  },
  PROPEL_SET_BUDGET: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/setyour-budget.png',
    ALT: 'Reward Programs - Rewards and Recognition',
  },
  PROPEL_RECOGNISE: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/recognise.png',
    ALT: 'Employee Recognition - Rewards and Recognition',
  },
  PROPEL_DISTRUBUTE_REWARDS: {
    URL: 'https://cdn.zaggle.in/images/web/propel/distribute-rewards.png',
    ALT: 'Reward Points - Rewards and Recognition',
  },
  PROPEL_REDEEM_SITE: {
    URL: 'https://cdn.zaggle.in/images/web/propel/icons/redeem-at-site.png',
    ALT: 'Redeem Points - Rewards and Recognition',
  },
  PROPEL_BGPOINTS: 'https://cdn.zaggle.in/images/web/propel/banner/points-bg.jpg',
  PROPEL_HEART: 'https://cdn.zaggle.in/images/web/propel/icons/love-red.png',
  PROPEL_INCENTIVE: {
    URL: 'https://cdn.zaggle.in/images/web/propel/banner/incentives.png',
    ALT: 'Channel Incentives Program - Rewards and Recognition',
  },
  ZAGGLE_GREY_LOGO: 'https://cdn.zaggle.in/images/web/propel/zaggle-logo-gray.jpg',
  ZAGGLE_PARTY: 'https://cdn.zaggle.in/images/web/propel/party-img.jpg',
  ABOUTUS_WALL: 'https://cdn.zaggle.in/images/web/zaggle/webp/about-us-bg.webp', // jpg
  ABOUTUS_AMITION_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/ambition.png',
    ALT: 'No Compromise to Provide Best Service',
  },
  ABOUTUS_SERVICE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/service.png',
    ALT: 'Best Product to Customer',
  },
  ABOUTUS_SIMPLICITY_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/simplicity.png',
    ALT: 'Simple and Intuitive',
  },
  ABOUTUS_EFFICIENCY_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/efficiency.png',
    ALT: 'Save Time and Money',
  },
  ABOUTUS_TRANSPARENCY_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/transparency.png',
    ALT: 'Able to View All Charges',
  },
  ABOUTUS_ABOUT_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/about-image.webp', // png
    ALT: 'Zaggle Annaual Growth',
  },
  ABOUTUS_OFFICE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/9-offices.png',
    ALT: 'All Branches - Zaggle Offices',
  },
  ABOUTUS_ZAGGLERS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/zagglers.png',
    ALT: 'Employees Working for Zaggle',
  },
  ABOUTUS_CORPORATE_CLIENT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/corporate-clients.png',
    ALT: 'Corporate Clients Under Zaggle',
  },
  ABOUTUS_MERCHANT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/merchant-relationships.png',
    ALT: 'Merchants with Zaggle',
  },
  ABOUTUS_GIFTCARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/gift-cards-in-the-market.png',
    ALT: 'Zaggle Gift Cards Users',
  },
  ABOUTUS_ZAGGLE_PLATFORM: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/users-across-zaggle-platforms.png',
    ALT: 'Zaggle Platform Users',
  },
  ABOUTUS_MAP_PIN: 'https://cdn.zaggle.in/images/web/zaggle/map-pin.png',
  ABOUTUS_INDIA_MAP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/india-map.webp', // png
    ALT: 'Zonal view of our Locations - Zaggle ',
  },
  TEAM_WALL: 'https://cdn.zaggle.in/images/web/zaggle/webp/team-bg.webp', // jpg
  TEAM_FOUNDER: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/phani.webp', // jpg
    ALT: 'Our Founder - Zaggle',
  },
  TEAM_FOUNDER_LINKEDIN: 'https://www.linkedin.com/in/raj-n-phani-8735858/',
  TEAM_CEO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/avinash.webp', // jpg
    ALT: 'Our Chief Executive Officer - Zaggle',
  },
  TEAM_CEO_LINKEDIN: 'https://www.linkedin.com/in/avinashgodkhindi/',
  TEAM_VP_PROD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/rajashekar.webp', // jpg
    ALT: 'Our Vice President - Zaggle',
  },
  TEAM_VP_PROD_LINKEDIN: 'https://www.linkedin.com/in/rajsekhar/',
  TEAM_CFO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/samarvijaypupala.jpg',
    ALT: 'Our Chief Financial Officer - Zaggle',
  },
  TEAM_CTO_LINKEDIN: 'https://www.linkedin.com/in/sivavks/',
  TEAM_CTO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/sivakumarvondivillu.webp', // jpg
    ALT: 'Our Chief Technology Officer - Zaggle',
  },
  TEAM_CFO_LINKEDIN: 'https://in.linkedin.com/in/samarvijaypupala',
  TEAM_SALES: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/tushar.webp ', // jpg
    ALT: 'Our Regional Sales Head - Zaggle',
  },
  TEAM_SALES_LINKEDIN: 'https://www.linkedin.com/in/tushar-patil-5a3261125/',
  TEAM_OPERATION: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/abhishak.webp', // jpg
    ALT: 'Our Head of Operations - Zaggle',
  },
  TEAM_OPERATION_LINKEDIN: 'https://www.linkedin.com/in/shreekanth-dhond-57926722/',
  TEAM_HR: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/priti.webp', // jpg
    ALT: 'Our Senior Manager Human Resources - Zaggle',
  },
  TEAM_HR_LINKEDIN: 'https://www.linkedin.com/in/priti-mhatre-64579723',
  TEAM_STRATEGIC: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/abhishek.webp', // jpg
    ALT: 'Our Head Strategic Partner & New Initiatives - Zaggle',
  },
  TEAM_STRATEGIC_LINKEDIN: 'https://www.linkedin.com/in/abhishek-bhattacharjee-84426863',
  CAREER_WALL: 'https://cdn.zaggle.in/images/web/zaggle/webp/careers-bg.webp', // jpg
  CAREER_INTRAPRENEUR: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/become-an-intrapreneur.png',
    ALT: 'Become an Intrapreneur - Zaggle Career Benefits',
  },
  CAREER_OPEN_COMMUNICATION: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/open-co.png',
    ALT: 'Build Culture Around Authenticity and Integrity - Zaggle Career Benefits',
  },
  CAREER_ZAGGLE_VISA: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/zaggle-visa.png',
    ALT: 'Prepaid Cards to Save Empoyee Tax Benefits  - Zaggle Career Benefits',
  },
  CAREER_TEAM_SOCIAL: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team-socials.png',
    ALT: 'High Employee Engagement  - Zaggle Career Benefits',
  },
  CAREER_BEST_GOODIES: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/best-goodies.png',
    ALT: 'Best Induction Kits  - Zaggle Career Benefits',
  },
  CAREER_REWARDS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/rewards-and-rec.png',
    ALT: 'Rewards & Recognition  - Zaggle Career Benefits',
  },
  PRESS_WALL_1: 'https://cdn.zaggle.in/images/web/zaggle/webp/press-1.webp', // jpg
  PRESS_WALL_2: 'https://cdn.zaggle.in/images/web/zaggle/webp/press-2.webp', // jpg
  PRESS_WALL_3: 'https://cdn.zaggle.in/images/web/zaggle/webp/press-3.webp', // jpg
  PRESS_WALL_MOBILE_1: 'https://cdn.zaggle.in/images/web/zaggle/webp/mobile-press-1.webp', // jpg
  PRESS_WALL_MOBILE_2: 'https://cdn.zaggle.in/images/web/zaggle/webp/mobile-press-2.webp', // jpg
  PRESS_WALL_MOBILE_3: 'https://cdn.zaggle.in/images/web/zaggle/webp/mobile-press-3.webp', // jpg
  PRESS_PAYMENT_SUMMIT: 'https://www.payments-cards.com/',
  PRESS_HYSEA_SUMMIT: 'https://www.thehindubusinessline.com/companies/infosys-tcs-techm-bag-hysea-awards/article28793390.ece',
  PRESS_IAMAI_SUMMIT: 'http://www.uniindia.com/zaggle-wins-best-prepaid-card-solution-at-iamai-india-digital-summit-2019/business-economy/news/1477119.html',
  PRESS_KETAN_1: 'http://www.thehansindia.com/posts/index/Business/2018-10-05/Zaggle-partners-with-Ketan-Diamonds/419249',
  PRESS_KETAN_2: 'https://www.apnnews.com/zaggle-announces-corporate-partnership-with-ketan-diamonds/',
  PRESS_ZAGGLE_REVENUE: 'https://yourstory.com/2018/08/zaggle-grew-revenues-6x-rs-650-crore-just-year?fbclid=IwAR1KeCLsygBSCWR6lbjyIvAJO8l-vJ_ixVeWKV_cC5iPBPf3M4fxc1sJR2Y',
  PRESS_CLICK_PAY: 'https://www.vccircle.com/enterprise-cashback-firm-zaggle-buys-payments-company-click-pay/',
  PRESS_ZAGGLE_TCS: 'https://www.indiatoday.in/pti-feed/story/total-sets-up-digital-innovation-centre-in-india-with-tcs-1288538-2018-07-17',
  CONTACTUS_WALL: 'https://cdn.zaggle.in/images/web/zaggle/webp/contact-us-bg.webp', // jpg
  CONTACTUS_GOOLE_FORM: 'https://docs.google.com/forms/u/3/d/e/1FAIpQLSdrcDEr1ChsMlmPhq2Lsacvmd_w4ZbF7M4OGEwFle4mgtLp6A/formResponse',
  LANDING_ARTBOARD_1: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/artboard-1.png',
    ALT: 'Easily Adaptable',
  },
  LANDING_ARTBOARD_2: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/artboard-2.png',
    ALT: 'Good in Performance',
  },
  LANDING_ARTBOARD_3: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/artboard-3.png',
    ALT: 'Produce a Range of Capabilities',
  },
  LANDING_ARTBOARD_4: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/artboard-4.png',
    ALT: 'Modified to Suit a Particular Task',
  },
  LANDING_PROPEL_1: 'https://cdn.zaggle.in/images/web/zaggle/webp/home-img4.webp', // png
  LANDING_PROPEL_2: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/home-img4-desk.webp', // png
    ALT: 'Reward, Recognition and Incentives',
  },
  LANDING_EDGE_1: 'https://cdn.zaggle.in/images/web/zaggle/webp/home-img3.webp', // png
  LANDING_EDGE_2: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/home-img3-desk.webp', // png
    ALT: 'Prepaid Gift Cards',
  },
  LANDING_SAVE_1: 'https://cdn.zaggle.in/images/web/zaggle/webp/home-img1.webp', // png
  LANDING_SAVE_2: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/home-img1-desk.webp', // png
    ALT: 'Expense Management, Employee Tax Benefits',
  },
  LANDING_SAVE_PLUS_1: 'https://cdn.zaggle.in/images/web/zaggle/webp/home-img2.webp', // png
  LANDING_SAVE_PLUS_2: 'https://cdn.zaggle.in/images/web/zaggle/webp/home-img2-desk.webp', // png
  LANDING_SELECT_1: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/select-home-banner.webp', // png
    ALT: 'Special Projects',
  },
  LANDING_SELECT_2: 'https://cdn.zaggle.in/images/web/zaggle/webp/select-home-banner.webp', // png
  LANDING_LOVE: 'https://cdn.zaggle.in/images/web/zaggle/love.png',
  LANDING_ZAGGLE_WHITE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/zaggle-logo-white.png',
    ALT: 'Zaggle - Rewards and Recognition | Expense Management | Employee Benefits',
  },
  LANDING_SLIDE_ONE: 'https://cdn.zaggle.in/images/web/zaggle/webp/slide1.webp', // jpg
  LANDING_SLIDE_TWO: 'https://cdn.zaggle.in/images/web/zaggle/webp/slide2.webp', // jpg
  LANDING_SLIDE_THREE: 'https://cdn.zaggle.in/images/web/zaggle/webp/slide3.webp', // jpg
  LANDING_SLIDE_FOUR: 'https://cdn.zaggle.in/images/web/zaggle/webp/slide4.webp', // jpg
  LANDING_POPUP: 'https://cdn.zaggle.in/images/web/save/save-website-banner.jpg',
  HERO_BG: 'https://cdn.zaggle.in/images/web/zaggle/hero-bg.png',
  TRUSTED_BG: 'https://cdn.zaggle.in/images/web/zaggle/webp/trusted-bg.webp', // png
  BLOCK_BG: 'https://cdn.zaggle.in/images/web/zaggle/block-bg.png',
  SMALL_BG: 'https://cdn.zaggle.in/images/web/save/small-bg.png',
  SMALL_BG_2: 'https://cdn.zaggle.in/images/web/propel/banner/small-bg2.png',
  VIDEO_BG: 'https://cdn.zaggle.in/images/web/zaggle/video-bg.jpg',
  NEWS_LETTER_BG: 'https://cdn.zaggle.in/images/web/zaggle/newsletter-bg.jpg',
  QUOTE_RIGHT: 'https://cdn.zaggle.in/images/web/zaggle/quote-right.png',
  QUOTE_LEFT: 'https://cdn.zaggle.in/images/web/zaggle/quote-left.png',
  RED_BOTTOM: 'https://cdn.zaggle.in/images/web/zaggle/red-bottom.png',
  GRADIENT_ELEMENT: 'https://cdn.zaggle.in/images/web/save/gradient-element.png',
  DOTS_BG: 'https://cdn.zaggle.in/images/web/zaggle/dots-bg.png',
  POINTS_BOTTOM: 'https://cdn.zaggle.in/images/web/zaggle/point-bottom.jpg',
  POINTS_TOP: 'https://cdn.zaggle.in/images/web/zaggle/points-top.jpg',
  CONACT_BG: 'https://cdn.zaggle.in/images/web/zaggle/webp/contact-bg.webp', // png
  PROPEL_LOGIN_BG: 'https://cdn.zaggle.in/images/web/zaggle/webp/propel-login-bg.webp', // png
  HIW_CUSTOMIZE_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/order-customized-cards.png',
    ALT: 'Customized Cards - Corporate Gifting',
  },
  HIW_DISTRIBUTE: {
    URL: 'https://cdn.zaggle.in/images/web/save/distribute.png',
    ALT: 'Physical card, E Gift Card - Corporate Gifting',
  },
  HIW_EMP_SPENDING: {
    URL: 'https://cdn.zaggle.in/images/web/save/employee-spendings.png',
    ALT: 'Spend Online and Offline - Corporate Gifting',
  },
  DS_SAVE_TIME: {
    URL: 'https://cdn.zaggle.in/images/web/save/save-time.png',
    ALT: 'Vendor Management, Logistics - Corporate Gifting',
  },
  DS_CUSTOMIZE: {
    URL: 'https://cdn.zaggle.in/images/web/save/customize.png',
    ALT: 'Customized Cards - Corporate Gifting',
  },
  DS_COMP_DIGITAL: {
    URL: 'https://cdn.zaggle.in/images/web/save/completely-digital.png',
    ALT: 'E Gift Card, E Gift Vouchers - Corporate Gifting',
  },
  DS_NO_LOCATION: {
    URL: 'https://cdn.zaggle.in/images/web/save/no-location-constraints.png',
    ALT: 'Locally or Globally - Corporate Gifting',
  },
  DS_ZERO_PILFERAGE: {
    URL: 'https://cdn.zaggle.in/images/web/save/zero-pilferage.png',
    ALT: 'No Stealing, No Loss - Corporate Gifting',
  },
  DS_SAVE_TAX: {
    URL: 'https://cdn.zaggle.in/images/web/save/save-tax.png',
    ALT: 'Save Tax, Tax Benefits - Corporate Gifting',
  },
  GIFT_MILESTONE: {
    URL: 'https://cdn.zaggle.in/images/web/save/milestone-awards.png',
    ALT: 'Mile Stone Awards - Corporate Gifting',
  },
  GIFT_INDUCTION: {
    URL: 'https://cdn.zaggle.in/images/web/save/induction-gifting.png',
    ALT: 'Employee Induction - Corporate Gifting',
  },
  GIFT_PERFORMANCE: {
    URL: 'https://cdn.zaggle.in/images/web/save/performance-awards.png',
    ALT: 'Performance Awards - Corporate Gifting',
  },
  GIFT_INCENTIVE: {
    URL: 'https://cdn.zaggle.in/images/web/save/incentives.png',
    ALT: 'Incentives - Corporate Gifting',
  },
  GIFT_BIRTHDAY: {
    URL: 'https://cdn.zaggle.in/images/web/save/birthdays.png',
    ALT: 'Birthdays - Corporate Gifting',
  },
  GIFT_FESTIVE: {
    URL: 'https://cdn.zaggle.in/images/web/save/festiv-gifting.png',
    ALT: 'Festival Gifting - Corporate Gifting',
  },
  GIFT_CHANNEL: {
    URL: 'https://cdn.zaggle.in/images/web/save/channel-gifting.png',
    ALT: 'Channel Gifting - Corporate Gifting',
  },
  GIFT_ANNIVERSARY: {
    URL: 'https://cdn.zaggle.in/images/web/save/work-anniversaries.png',
    ALT: 'Work Anniversary - Corporate Gifting',
  },
  GIFT_LONG_SERVICE: {
    URL: 'https://cdn.zaggle.in/images/web/save/long-service.png',
    ALT: 'Long Service Award - Corporate Gifting',
  },
  CARD_BOMB: {
    URL: 'https://cdn.zaggle.in/images/web/save/bomb-logos.png',
    ALT: 'Entertainment, Movies, Parks, Spas - Corporate Gifting',
  },
  CARD_ZEON: {
    URL: 'https://cdn.zaggle.in/images/web/save/zeon-logos.png',
    ALT: 'Electronics, Lifestyle, Kitchenware, Furniture - Corporate Gifting',
  },
  CARD_WAVES: {
    URL: 'https://cdn.zaggle.in/images/web/save/wave-logos.png',
    ALT: 'Corporate Gift Vouchers',
  },
  CARD_KUBER_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/kuber-card.jpg',
    ALT: 'Zaggle Kuber Gift Card, Prepaid Card, Gift Card - Corporate Gifting',
  },
  CARD_BOMB_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/bomb-card.jpg',
    ALT: 'Zaggle BoMB Gift Card, Prepaid Card, Gift Card  - Corporate Gifting',
  },
  CARD_ZEON_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/zeon-card.png',
    ALT: 'Zaggle Zeon Gift Card, Prepaid Card, Gift Card  - Corporate Gifting',
  },
  CARD_WAVE_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/wave-card-2.png',
    ALT: 'Zaggle Wave Gift Card, Prepaid Card, Gift Card  - Corporate Gifting',
  },
  CARD_WHEEL_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/wheel-card.png',
    ALT: 'Zaggle Wheels Gift Card, Automobiles, Prepaid Card, Gift Card  - Corporate Gifting',
  },
  CARD_PETRO_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/petro-card.png',
    ALT: 'Zaggle Petro Gift Card, Fuel Stations, Prepaid Card, Gift Card  - Corporate Gifting',
  },
  CARD_KOHINOOR_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/save/kohinoor-card-2.png',
    ALT: 'Zaggle Kohinoor Gift Card, Jewlery Stores, Prepaid Card, Gift Card  - Corporate Gifting',
  },
  EMP_GIFT_ENGAGEMENT: {
    URL: 'https://cdn.zaggle.in/images/web/save/better-employee-engagement.png',
    ALT: 'Employee Engagement -Corporate Gifting',
  },
  EMP_GIFT_RETENTION: {
    URL: 'https://cdn.zaggle.in/images/web/save/increase-employee-retentioin.png',
    ALT: 'Employee Retention - Corporate Gifting',
  },
  EMP_GIFT_IMPROVE_HAPPINESS: {
    URL: 'https://cdn.zaggle.in/images/web/save/improve-happiness.png',
    ALT: 'Employee Motivation - Corporate Gifting',
  },
  EMP_GIFT_PROMOTE_INNOVATION: {
    URL: 'https://cdn.zaggle.in/images/web/save/promote-innovation.png',
    ALT: 'Promote Innovation - Corporate Gifting',
  },

  SIGNUP_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/icons/webp/sign-up-icon.webp', // png
    ALT: 'Sign up or Login if already registerd',
  },
  ADDCARD_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/icons/webp/add-card-icon.webp', // png
    ALT: 'Add Card, View Your Cards',
  },
  VIEWTRANS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/icons/webp/view-trans-icon.webp', // png
    ALT: 'Manage cards, Redeem Points, Zaggle Propel card, Zaggle Cards',
  },
  ZAGGLE_CARD_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/icons/zaggle-card-icon.png',
    ALT: 'Manage cards, Redeem Points, Zaggle Propel card, Zaggle Cards',
  },
  ZAGGLE_CASH_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/icons/zaggle-cash-icon.png',
    ALT: 'Manage cards, Redeem Points, Zaggle Propel card, Zaggle Cards',
  },
  ZAGGLE_CART_IMG: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/cart-icon.svg',
    ALT: 'View Cart, Cart Items, Zaggle Cart',
  },
  SEND_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/send-icon.svg',
    ALT: 'alt',
  },
  TWITTWR_X: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/twitter-x-icon.png',
    ALT: 'Twitter X',
  },
  THANKYOU_EMAIL: 'https://cdn.zaggle.in/images/web/zaggle/email.png',
  THANKYOU_CALL: 'https://cdn.zaggle.in/images/web/zaggle/call.png',
  THANKYOU_BG: 'https://cdn.zaggle.in/images/web/zaggle/thank-you.jpg',
  ZAGGLE_FB: 'https://www.facebook.com/zaggleapp/',
  ZAGGLE_TWITTER: 'https://twitter.com/zaggleapp',
  ZAGGLE_INSTAGRAM: 'https://www.instagram.com/zaggleapp/',
  ZAGGLE_LINKEDIN: 'https://www.linkedin.com/company/zaggle-prepaid-ocean-services-pvt-ltd-/',
  ZAGGLE_YOUTUBE: 'https://www.youtube.com/channel/UCF44bUtUAgnMNOTzyvXvkgQ?view_as=subscriber',
  ZAGGLE_MAIL_ICON: 'https://cdn.zaggle.in/images/web/zaggle/email-icon2.png',
  SAVE_CALCULATE_BG: 'https://cdn.zaggle.in/images/web/zaggle/webp/copy-of-cost.webp', // png
  SAVE_CALCULATE_MOBILE: 'https://cdn.zaggle.in/images/web/zaggle/webp/calculate-your-potential.webp', // png
  MERCHANT_REWARD_WALL: 'https://cdn.zaggle.in/images/web/zaggle/webp/merchant-bg.webp', // jpg
  MERCHANT_BRAND_AWARENESS: 'https://cdn.zaggle.in/images/web/zaggle/create-brand-awareness.png',
  MERCHANT_CORPORATE_GIFT: 'https://cdn.zaggle.in/images/web/zaggle/corporate-gifting.png',
  MERCHANT_ADVANCE_CAPITAL: 'https://cdn.zaggle.in/images/web/zaggle/advance-working-capital.png',
  MERCHANT_TOUP_SELL: 'https://cdn.zaggle.in/images/web/zaggle/opportunity-to-up-sell.png',
  MERCHANT_INCREASED_REVENUES: 'https://cdn.zaggle.in/images/web/zaggle/increased-revenues.png',
  MERCHANT_MARKETING_CAMPAIGN: 'https://cdn.zaggle.in/images/web/zaggle/marketing-campaigns.png',
  MERCHANT_CARD: 'https://cdn.zaggle.in/images/web/zaggle/webp/cards.webp', // png
  MERCHANT_SECURE_PLATFORM: 'https://cdn.zaggle.in/images/web/zaggle/secure-platform.png',
  MERCHANT_SECURE_CUSTOMIZATION: 'https://cdn.zaggle.in/images/web/zaggle/customization.png',
  MERCHANT_MARKETING_SUPPORT: 'https://cdn.zaggle.in/images/web/zaggle/marketing-support.png',
  MERCHANT_MIS_DASHBOARD: 'https://cdn.zaggle.in/images/web/zaggle/mis-and-dashboard.png',
  MERCHANT_ALLIANCES: 'https://cdn.zaggle.in/images/web/zaggle/alliances-and-strategic.png',
  MERCHANT_MULTIPLE_SALES: 'https://cdn.zaggle.in/images/web/zaggle/multiple-sales.png',
  MERCHANT_HAND_SHARE: 'https://cdn.zaggle.in/images/web/zaggle/webp/hand-share.webp', // png
  MERCHANT_IMAGE: 'https://cdn.zaggle.in/images/web/zaggle/merchant.png',
  MERCHANT_ADD_FUNDS: 'https://cdn.zaggle.in/images/web/zaggle/add-funds.png',
  MERCHANT_TOP_UP: 'https://cdn.zaggle.in/images/web/zaggle/top-up.png',
  NIPPON_LOGO: 'https://www.zaggle.in/images/propel/MicroSites/nippon-logo.png',
  FORD_LOGO: 'https://www.zaggle.in/images/propel/MicroSites/ford/logo.png',
  MANIPAL_LOGO: 'https://cdn.zaggle.in/images/web/propel/client/manipal-logo.png',
  MANIPAL_STORE_LOGO: 'https://cdn.zaggle.in/images/web/propel/client/manipal-brand-logo.png',
  MANIPAL_LOGO_SMALL: 'https://cdn.zaggle.in/images/web/propel/client/manipal-logo-small.png',
  MANIPAL_INNER_LOGO: 'https://cdn.zaggle.in/images/web/propel/client/manipal-inner-logo.png',
  MANIPAL_TOP_BANNER: 'https://cdn.zaggle.in/images/web/propel/client/manipal/manipalsigna-top-banner.png', // No Use Need to Remove
  Mani1: {
    URL: 'https://cdn.zaggle.in/images/web/propel/client/manipal/manipalcigna-banner.png',
    ALT: 'Manipal Cigna',
  },
  PROPPEL_CORP_GIFTING_CAMPAIGN: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/client/propel/diwali/propel-corporate-gifting-landing-banner.png',
    ALT: 'Diwali Campaign',
  },
  MANIPAL_HOME_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/catalog-icon.svg',
    ALT: 'Manipalcigna Home Logo',
  },
  Ford1: 'https://www.zaggle.in/images/propel/MicroSites/ford/banner-1.jpg',
  Ford2: 'https://www.zaggle.in/images/propel/MicroSites/ford/banner-2.jpg',
  Ford3: 'https://www.zaggle.in/images/propel/MicroSites/ford/banner-3.jpg',
  CLINET_BACKGROUND: 'https://cdn.zaggle.in/images/web/zaggle/client/webp/client-bg.webp', // png

  SAVEPLUS_WALL_MOBILE: 'https://cdn.zaggle.in/images/web/zaggle/webp/employee-benefits-mobile.webp', // jpg

  MOBIKWIK_VOUCHER: 'https://cdn.zaggle.in/images/web/zaggle/webp/mobikwik-voucher.webp', // jpeg
  MOBIKWIK_VOUCHER_NEW: 'https://cdn.zaggle.in/images/web/zaggle/mobikwik-voucher-new.png',

  // New Landing Images
  ZAGGLECARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/zaggle-card.png',
    ALT: 'Zaggle Card',
  },
  CROCURY_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/card-crockery-icon.svg',
    ALT: 'Zaggle Card',
  },
  CARD_GIFT_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/card-gift-icon.svg',
    ALT: 'Zaggle Card',
  },
  CARD_MONEY_BILL: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/card-money-bill.svg',
    ALT: 'Zaggle Card',
  },
  PROFILE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/profile-icon.svg',
    ALT: 'Zaggle Card',
  },
  PROFILE_ORDER: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/profile-order.svg',
    ALT: 'Zaggle Card',
  },
  PROFILE_GIFT_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/profile-gift-card.svg',
    ALT: 'Zaggle Card',
  },
  PROFILE_MONEY: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/profile-money.svg',
    ALT: 'Zaggle Card',
  },
  PROFILE_LOGOUT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/profile-logout.svg',
    ALT: 'Zaggle Card',
  },
  PROFILE_CARD_ACCOUNT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/profile-card-account.svg',
    ALT: 'Zaggle Card',
  },
  LOGIN_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/login-card.webp', // png
    ALT: 'Zaggle Login card',
  },
  HIW_SIGNUP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/HIW_signup.svg',
    ALT: 'Zaggle Login card',
  },
  HTW_ADDCARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/HIW_addcard.svg',
    ALT: 'Zaggle Login card',
  },
  HIW_TRANSACTIONS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/HIW_transactions.svg',
    ALT: 'Zaggle Login card',
  },
  ZAGGLE_CARD_FRONT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/yes-bank-rupay-zinger-card-frontside.png', // png
    ALT: 'Zaggle Login card',
  },
  ZAGGLE_CARD_BACK: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/yes-bank-rupay-zinger-card-backside.png', // png
    ALT: 'Zaggle Login card',
  },
  // Features
  FEATURE_SAVE_TWO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/save-new.webp', // png
    ALT: 'Feature Save',
  },
  FEATURE_PROPEL_TWO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/propel-header.webp', // png
    ALT: 'Feature Save',
  },
  FEATURE_ZOYER_TWO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/zoyer-header.webp', // png
    ALT: 'Feature Save',
  },
  FEATURE_SAVE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/feature-save.webp', // png
    ALT: 'Feature Save',
  },
  FEATURE_SAVE_NEW: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/save-header.webp', // png
    ALT: 'Feature Save',
  },
  FEATURE_PROPEL: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/landing-incentive.webp', // png
    ALT: 'Feature Propel',
  },
  FEATURE_PROPEL_NEW: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/propel-header.webp', // png
    ALT: 'Feature Propel',
  },
  FEATURE_ZOYER: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/zoyer-header.webp', // png
    ALT: 'Feature Propel',
  },
  FEATURE_EDGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/landing-giftcard.webp', // png
    ALT: 'Feature Edge',
  },
  FEATURE_BANC: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/landing-neobanking.webp', // png
    ALT: 'Feature Banc',
  },
  FEATURE_FOUNDERS_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/landing-founderscard.webp', // png
    ALT: 'Feature Founders Card',
  },
  WHITE_TICK_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/tick.png',
    ALT: 'alt',
  },
  // Zaggle in News
  ZAGGLE_NEWS_LEADER: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/most-promising-award.png',
    ALT: 'Most Promising Business Leaders of Asia 2020',
  },
  ZAGGLE_NEWS_FINTECH: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/best-fintech-award.webp', // png
    ALT: 'Best Fintech Corporate Innovation Program award',
  },
  ZAGGLE_NEWS_FOUNDER: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/zaggle-news.webp', // png
    ALT: 'Zaggle in News Blog COVID-19',
  },
  ZAGGLE_NEWS_CORPORATE_CREDIT_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/zaggle-news-2.webp', // png
    ALT: 'Zaggle in News Press Corporate Credit Card',
  },
  ZAGGLE_NEWS_FINTECH_STARTUP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/zaggle-news-3.webp', // png
    ALT: 'Zaggle in News Press Fintech Startup',
  },
  // Zaggle Details
  ZAGGLE_NEWS_ISO_IMG: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/iso-image-one.webp', // png
    ALT: 'ISO/IECF 27001:2013 Certified',
  },
  ZAGGLE_NEWS_ISO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/iso-image-two.png',
    ALT: 'ISO 9001:2015 Certified',
  },
  ZAGGLE_NEWS_GDPR_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/gdpr-logo.webp',
    ALT: 'GDPR',
  },
  ZAGGLE_NEWS_ALL_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/zaggle-secureaty-certificates.png',
    ALT: 'all',
  },
  ZAGGLE_NEWS_WEB_SEAL: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/web-seal.webp', // png
    ALT: 'Web Seal Certified',
  },
  ZAGGLE_DETAILS_CORPORATE_CILENTS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/corporate-clients-logo.svg',
    ALT: 'Zaggle Details Corporate Cilents',
  },
  ZAGGLE_DETAILS_MERCHANT_RELATIONSHIPS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/merchant-relationships-logo.svg',
    ALT: 'Zaggle Details Merchant Relationship',
  },
  ZAGGLE_DETAILS_MILLION_USERS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/million-users-logo.svg',
    ALT: 'Zaggle Details Million Users',
  },
  ZAGGLE_DETAILS_MILLION_GIFTCARDS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/million-giftcards-logo.svg',
    ALT: 'Zaggle Details Million Giftcards',
  },
  ZAGGLE_DETAILS_APP_DOWNLOADS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/app-downloads-logo.svg',
    ALT: 'Zaggle Details App Downloads',
  },
  ZAGGLE_DETAILS_EMPLOYEES_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/employees-logo.svg',
    ALT: 'Zaggle Details Employees',
  },
  ZAGGLE_DETAILS_OFFICES_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/offices-logo.svg',
    ALT: 'Zaggle Details Offices',
  },
  ZAGGLE_DETAILS_BANKING_PARTNERS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/banking-partners-logo.svg',
    ALT: 'Zaggle Details Banking Partners',
  },
  ZAGGLE_DETAILS_NETWORK_PARTNERS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/network-partners-logo.svg',
    ALT: 'Zaggle Details Network Partners',
  },
  // Built in Everyone
  BUILT_EVERYONE_STARTUP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/startups.webp', // png
    ALT: 'Financial Technology Company',
  },
  BUILT_EVERYONE_SMES: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/smes.webp', // png
    ALT: 'Digital Bank in India',
  },
  BUILT_EVERYONE_CORPORATE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/corporates.webp', // png
    ALT: 'Financial Technology Company',
  },
  BUILT_EVERYONE_TEAM_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/team-icon.svg',
    ALT: 'Build in Everyone Team Icon',
  },
  BUILT_EVERYONE_CARD_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/cards-icon.svg',
    ALT: 'Build in Everyone Cards Icon',
  },
  BUILT_EVERYONE_FLOW_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/flow-icon.svg',
    ALT: 'Build in Everyone Flow Icon',
  },
  // Awards
  START_RIBBION_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/star-img-icon.svg',
    ALT: 'Star Ribbion Icon',
  },
  ZAGGLE_AWARDS_WON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/award-won.webp', // png
    ALT: 'Zaggle Awards Won',
  },
  ZAGGLE_LEADERSHIP_TALK: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/leadership-talk-new.webp', // png
    ALT: 'Zaggle Leadership Talk',
  },
  // Insights
  ZAGGLE_INSIGHTS_E_BOOK: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/e-book.webp', // png
    ALT: 'Zaggle Insight E-book',
  },
  ZAGGLE_INSIGHTS_NEWS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/news.webp', // png
    ALT: 'Zaggle Insight News',
  },
  ZAGGLE_INSIGHTS_WEBINAR: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/webinar.webp', // png
    ALT: 'Zaggle Insight Webinar',
  },
  ZAGGLE_INSIGHTS_BLOG: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/blog.webp', // png
    ALT: 'Zaggle Insight Blog',
  },
  ZAGGLE_INSIGHTS_PRESS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/press.webp', // png
    ALT: 'Zaggle Insight Press',
  },
  ZAGGLE_INSIGHTS_EBOOK: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/ebook.webp', // png
    ALT: 'Zaggle Insight Ebook',
  },
  ZAGGLE_INSIGHTS_STAR_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/start-bg.svg',
    ALT: 'Zaggle Insight Star Icon',
  },
  // Journey
  ZAGGLE_JOURNEY: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/Journey.webp', // png
    ALT: 'Zaggle Journey',
  },
  // Solutions-StartUp
  SOLUTIONS_STARTUP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/solutions-image.webp', // png
    ALT: 'Zaggle Solutions Startup',
  },
  DUMMY_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/dummy-image.svg',
    ALT: 'Dummy Image',
  },
  STARTUP_BOOST: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/boost-the-motivation.webp', // png
    ALT: 'boost the motivation',
  },
  STARTUP_GIVE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/give-reasons-stay.webp', // png
    ALT: 'boost the motivation',
  },
  STARTUP_MAINTAIN: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/maintain-transparency.webp', // png
    ALT: 'maintain transparency',
  },
  SME_OVER: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/an-overwhelming-memory.webp', // png
    ALT: 'an overwhelming memory',
  },
  SME_EMPLOYEE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/comprehensive-employee-management.png',
    ALT: 'comprehensive employee management',
  },
  SME_LOWER: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/lower-the-unauthorized-spent.webp', // png
    ALT: 'lower the unauthorized spent',
  },
  COPORATE_PERSONALIZE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/personalize-employee-expectations.png',
    ALT: 'personalize employee expectations',
  },
  COPORATE_SCALE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/scale-up-your-workflow.webp', // png
    ALT: 'scale up your workflow',
  },
  COPORATE_GET: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/get-on-the-same-page.webp', // png
    ALT: 'get on the same page',
  },
  // Employee Flexi Benefits
  EMPLOYEE_BENEFITS_LANDING_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/employee-benefits-dashboard.webp', // png
    ALT: 'Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  ONBOARDING_FLEXI_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/onboarding-flexi.webp', // png
    ALT: 'Onboarding Employee, Employee Flexible Benefits, Employee Tax Benefits',
  },
  TAX_BENEFITS_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/tax-benefits.webp', // png
    ALT: 'Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  FLEXIBLE_BENEFITS_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/flexible-benefits.webp', // png
    ALT: 'Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  MEAL_ALLOWANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/meal-allowance.svg',
    ALT: 'Meal Allowance, Meal Benefit, Employee Flexible Benefits, Employee Tax Benefits',
  },
  FUEL_ALLOWANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/fuel-allowance.svg',
    ALT: 'Fuel Allowance, Fuel Benefit, Employee Flexible Benefits, Employee Tax Benefits',
  },
  LTA_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/lta.svg',
    ALT: 'LTA, Employee Flexible Benefits, Employee Tax Benefits',
  },
  TELECOM_BROADBAND_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/telecom-broadband.svg',
    ALT: 'Telecom & Broadband Beneffits, Employee Flexible Benefits, Employee Tax Benefits',
  },
  BOOKS_PERIODICALS_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/books-periodicals.svg',
    ALT: 'Books & Periodicals, Employee Flexible Benefits, Employee Tax Benefits',
  },
  GIFT_ALLOWANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/gift-allowance.svg',
    ALT: 'Gift Allowance, Employee Flexible Benefits, Employee Tax Benefits',
  },
  TRANSPORT_ALLOWANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/transport-allowance.svg',
    ALT: 'Transport Allowance, Employee Flexible Benefits, Employee Tax Benefits',
  },
  DRIVER_ALLOWANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/driver-allowance.svg',
    ALT: 'Driver Allowance, Employee Flexible Benefits, Employee Tax Benefits',
  },
  UNIFORM_ALLOWANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/uniform-allowance.svg',
    ALT: 'Uniform Allowance, Employee Flexible Benefits, Employee Tax Benefits',
  },
  MULTI_WALLET_CARD_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/multi-wallet-card.svg',
    ALT: 'Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  WIDE_ACCEPTANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/wide-acceptance.svg',
    ALT: 'Wide Acceptance, Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  COMPLAINT_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/100-percent-complaint.svg',
    ALT: '100% complaint, Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  COMPLETE_COMPLIANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/complete-compliance.svg',
    ALT: 'Complete Compliance, Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  ONLINE_PAYMENT_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/online-payment.svg',
    ALT: 'Online Payment, Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  HIGH_SECURE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/high-secure.svg',
    ALT: 'High secure, Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  USER_FRIENDLY_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/user-friendly.svg',
    ALT: 'user friendly, Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  MOBILE_APPLICATION_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/mobile-application.svg',
    ALT: 'Mobile application, Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  STATEMENT_ACCOUNT_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/statement-account.svg',
    ALT: 'Statement & Account, Multi wallet benefits Card, Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits',
  },
  TAX_SAVE_FLEXI_BENEFITS_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/tax-save-flexi-benefits.webp', // png
    ALT: 'Multi Wallet Card, Real-Time Application',
  },
  ZAGGLE_EMPLOYEE_FLEXI_BENEFITS_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/zaggle-employee-logo.png',
    ALT: 'Zaggle Employee Flexi Benefits Logo',
  },
  // Copied From Zaggle Save
  PLATFORM_HOME: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/home-platform.png',
    ALT: 'Employee Benefits, Employee Tax Benefits, Employee Flexi Benefits, Employee Allowance',
  },
  TESTIMONIAL_QUOTE: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/testimonial-quote.png',
    ALT: 'alt',
  },
  TESTIMONIAL_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/testimonial-1.png',
    ALT: 'alt',
  },
  TESTIMONIAL_YAHOO: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/testi-yahoo.png',
    ALT: 'alt',
  },
  TESTIMONIAL_INNSURANCE: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/testi-edelweiss-tokio-life-lnsurance.png',
    ALT: 'alt',
  },
  TESTIMONIAL_AKKADO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/testimonials/webp/akkado-testimonial.webp', // png
    ALT: 'akkado company feedback to zaggle',
  },
  JOURNEY: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/journey-image.png',
    ALT: 'alt',
  },
  TRUSTED_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/propel/landing/trusted-clients.png',
    ALT: 'alt',
  },
  TRUSTED_ICON_NEW: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/Logos-bg.webp',
    ALT: 'alt',
  },
  TICK_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/tick.svg',
    ALT: 'alt',
  },
  WAVE_GIFTCARD_PARTNER_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/save/wave-logos.png',
    ALT: 'Corporate Gift Vouchers',
  },
  // Zaggle Edge Images
  ZAGGLE_EDGE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/zaggle-edge-logo.svg',
    ALT: 'Zaggle Edge Logo',
  },
  EDGE_LANDING_IMG: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/edge-landing-image.webp', // png
    ALT: 'Corporate Gifts for Employees',
  },
  BLACK_EMPTY_CARD_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/black-empty-card.svg',
    ALT: 'Empty Card',
  },
  TIME_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/time-icon.svg',
    ALT: 'Save time and efforts',
  },
  CARD_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/card-icon.svg',
    ALT: 'Customize the cards',
  },
  RECEIPT_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/receipt-icon.svg',
    ALT: 'Completely digital',
  },
  TRANSPARENCY_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/transparency-icon.svg',
    ALT: 'Zero pilferage, zero loss',
  },
  LOCATION_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/location-icon.svg',
    ALT: 'No location constraints',
  },
  TAX_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/tax-icon.svg',
    ALT: 'Save Tax',
  },
  INDUSIND_BANK_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/indusind-bank-logo.svg',
    ALT: 'Partner Indusind Bank',
  },
  YES_BANK_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/yesbank-logo.svg',
    ALT: 'Partner Yes Bank',
  },
  KUBER_GIFT_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/kuber-gift-card.webp', // png
    ALT: 'Kuber Gift Card Logo',
  },
  KUBER_GIFT_CARD_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/kuber-giftcard-logo.webp', // png
    ALT: 'Corporate Gift Card',
  },
  ZINGER_GPR_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/zinger-gpr-card.webp', // png
    ALT: 'Zinger GPR Card Logo',
  },
  ZINGER_MULTI_WALLET_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/zinger-multi-wallet.png',
    ALT: 'Zinger Multi Wallet Card Logo',
  },
  WAVE_GIFT_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/wave-gift-card.webp', // png
    ALT: 'Gift Cards in India',
  },
  WHEELS_GIFT_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/wheels-gift-card.webp', // png
    ALT: 'Wheels Gift Card Logo',
  },
  PETRO_GIFT_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/petro-gift-card.webp', // png
    ALT: 'Petro Gift Card Logo',
  },
  KOHINOOR_GIFT_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/kohinoor-gift-card.webp', // png
    ALT: 'Jewellery Gift Card',
  },
  KOHINOOR_GIFTCARD_PARTNER_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/kohinoor-giftcard-partner-logo.webp', // png
    ALT: 'Festive Gifting',
  },
  EDGE_JOURNEY: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/edge-journey.png',
    ALT: 'Edge Journey',
  },
  EDGE_MULTI_WALLET_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/zinger-multi-wallet-card.webp', // png
    ALT: 'Multi Walltet Card',
  },
  WHY_ZAGGLE_PREPAID_CARDS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/why-zaggle-prepaid-cards.webp', // png
    ALT: 'Corporate Gifting',
  },
  // Company Pages Images
  ABOUT_US_LANDING: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/about-us-landing.webp', // png
    ALT: 'About Us Landing Image',
  },
  ABOUT_US_GROUP_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/about-us-group-two.webp', // png
    ALT: 'About Us Group Image',
  },
  ABOUT_US_GROUP_IMAGE_TWO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/about-us-group-two.webp', // png
    ALT: 'About Us Group Image',
  },
  ABOUT_US_GROUP_ONE_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/about-us-group-one.webp', // png
    ALT: 'About Us Group Image',
  },
  ABOUT_US_MISSION_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/mission.svg',
    ALT: 'About Us Mission Image',
  },
  ABOUT_US_VISION_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/vision.svg',
    ALT: 'About Us Vision Image',
  },
  CONTACT_US_LANDING_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/contact-us-landing.webp', // png
    ALT: 'Contact Us Landing Image',
  },
  TEAM_LANDING_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/founder-team.webp', // png
    ALT: 'Team Landing Image',
  },
  FOUNDER_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/founder.webp', // png
    ALT: 'Founder Image',
  },
  CTO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/cto.webp', // png
    ALT: 'CTO Image',
  },
  CEO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/ceo.webp', // png
    ALT: 'CEO Image',
  },
  HR_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/hr.webp', // png
    ALT: 'HR Image',
  },
  VICE_PRESIDENT_PRODUCTS_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/vice-president-products.webp', // png
    ALT: 'Vice President Products Image',
  },
  REGIONAL_SALES_HEAD_WEST_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/regional-sales-head-west.webp', // png
    ALT: 'Regional Sales Head West Image',
  },
  CAREERS_CAROUSEL_IMAGE_ONE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-one.webp', // png
    ALT: 'Career Carousel Image One',
  },
  CAREERS_CAROUSEL_IMAGE_ONE_NEW: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/Images-2.webp', // png
    ALT: 'Career Carousel Image One',
  },
  CAREERS_CAROUSEL_IMAGE_TWO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-two.webp', // png
    ALT: 'Career Carousel Image Two',
  },
  CAREERS_CAROUSEL_IMAGE_THREE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-three.webp', // png
    ALT: 'Career Carousel Image Three',
  },
  CAREERS_CAROUSEL_IMAGE_THREE_NEW: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/Images-3.webp', // png
    ALT: 'Career Carousel Image Three',
  },
  CAREERS_CAROUSEL_IMAGE_FOUR: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-four.webp', // png
    ALT: 'Career Carousel Image Four',
  },
  CAREERS_CAROUSEL_IMAGE_FIVE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-five.webp', // png
    ALT: 'Career Carousel Image Five',
  },
  CAREERS_CAROUSEL_IMAGE_SIX: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-six.webp', // png
    ALT: 'Career Carousel Image Six',
  },
  CAREERS_CAROUSEL_IMAGE_SEVEN: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-seven.webp', // png
    ALT: 'Career Carousel Image Seven',
  },
  CAREERS_CAROUSEL_IMAGE_EIGHT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-eight.webp', // png
    ALT: 'Career Carousel Image Eight',
  },
  CAREERS_CAROUSEL_IMAGE_NINE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-nine.webp', // png
    ALT: 'Career Carousel Image Nine',
  },
  CAREERS_CAROUSEL_IMAGE_TEN: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-ten.webp', // png
    ALT: 'Career Carousel Image Ten',
  },
  CAREERS_CAROUSEL_IMAGE_ELVEN: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-eleven.webp', // png
    ALT: 'Career Carousel Image Eleven',
  },
  CAREERS_CAROUSEL_IMAGE_TWELVE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/career-card-twelve.webp', // png
    ALT: 'Career Carousel Image Twelve',
  },
  CAREERS_LANDING_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/careers-landing-image.webp', // png
    ALT: 'Career Landing Image',
  },
  NEWS_LANDING_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/news-landing-image.webp', // png
    ALT: 'News Landing Image',
  },
  NEWS_INTERNAL_LANDING_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/new-designs/webp/news-internal-landing.webp', // png
    ALT: 'News Internal Landing Image',
  },
  ZAGGLE_EMBLEM: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/svg/zaggle-round-logo.svg',
    ALT: 'Zaggle Emblem Image',
  },
  ZAGGLE_PRODUCT_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/edge/icons',
    ALT: 'Zaggle Product Image',
  },
  PARTNER_WITH_US: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/partner-with-us.webp', // jpg
    ALT: 'Partner with us',
  },
  // Payroll Card
  PAYROLL_CARD_LANDING_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/payroll-landing-image.webp', // png
    ALT: 'Payroll Card',
  },
  PAYROLL_POINTS_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/payroll-points-image.webp', // png
    ALT: 'Best Payroll Cards for Employees ',
  },
  PAYROLL_OUTLINE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/outline.svg',
    ALT: 'Employee Payroll Card',
  },
  PAYROLL_TAP_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/tap.svg',
    ALT: 'Pay Cards for Payroll',
  },
  PAYROLL_LOCK_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/lock.svg',
    ALT: 'Payroll Card Providers',
  },
  PAYROLL_MAINTENANCE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/maintenance.svg',
    ALT: 'Payroll Card',
  },
  PAYROLL_FINGERPRINT_SCANNING_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/fingerprint-scanning.svg',
    ALT: 'Employee Payroll Card',
  },
  PAYROLL_SURFACE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/surface.svg',
    ALT: 'Best Payroll Cards for Employees',
  },
  ZAGGLE_PAYROLL_CARD_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/logo/webp/zaggle-payroll-card-logo.webp', // png
    ALT: 'Zaggle Payroll Card Logo',
  },
  ZAGGLE_GLOBAL_DIGITAL_BANK_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/global-digital-bank.webp', // png
    ALT: 'Zaggle Global Digital Bank Logo',
  },
  VICE_PRESIDENT_PRODUCTS_IMAGE_NEW: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/rajashekar-new.webp', // jpg
    ALT: 'Vice President Products Image New',
  },
  COO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/arundathi.webp', // jpg
    ALT: ' COO Image New',
  },
  CSO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/vidya.webp', // jpg
    ALT: ' CFO Image New',
  },
  CFO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/Aditya.webp', // jpg
    ALT: ' CFO Image New',
  },
  CSCO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/Haripriya.webp', // jpg
    ALT: ' CFO Image New',
  },
  CPO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/sathish.webp', // jpg
    ALT: ' CPO Image New',
  },
  COMPLETE_CONTROL: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/complete-control.png',
    ALT: 'Complete Control Payroll Card',
  },
  WIDE_ACCEPTANCE: {
    URL: 'https://cdn.zaggle.in/images/web/save/contact/wide-acceptance.png',
    ALT: 'Employee Flexi Benefits',
  },
  PAY_ONLINE_UNIQUE_SECURITY: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/pay-online-unique-security.png',
    ALT: 'Pay Online Unique Security Payroll Card',
  },
  EASY_TO_USE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/easy-to-use.png',
    ALT: 'Easy to Use Payroll Card',
  },
  MOBILE_APP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/mobile-app.png',
    ALT: 'Mobile App Payroll Card',
  },
  SAVE_SMALL_BACKGROUND_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/edge/landing/small-bg.png',
    ALT: 'Payroll Card Light Blue Background Logo',
  },
  ORDER_CARDS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/order-cards.png',
    ALT: 'Order Cards Payroll Card',
  },
  START_PAYOUTS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/start-payouts.png',
    ALT: 'Start Payouts Payroll Card',
  },
  OFFER_USER_ACCESS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/offer-access-uses.png',
    ALT: 'Offer User Access Payroll Card',
  },
  CHRO_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/team/webp/paromita-debareng.webp', // jpg
    ALT: ' CHRO Image',
  },
  TRUSTED_SLIDE_ONE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/trusted-slide-1.webp', // png
    ALT: 'Trusted Brands Slide One',
  },
  TRUSTED_SLIDE_TWO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/trusted-slide-2.webp', // png
    ALT: 'Trusted Brands Slide Two',
  },
  TRUSTED_SLIDE_THREE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/trusted-slide-3.webp', // png
    ALT: 'Trusted Brands Slide Three',
  },
  HYD_SOONICORNS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/hyd-soonicorns.webp', // png
    ALT: 'Hyderabad Soonicorns',
  },
  ARUNDATHI_COO_NEWS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/arundhoti-banerjee-coo.png',
    ALT: 'Arundhoti-Banerjee-COO in News',
  },
  EARLY_SALARY: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/early-salary.png',
    ALT: 'Early Salary in News',
  },
  FINTECH_ZAGGLE_LAUNCH: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/zaggle-home-news-one.webp',
    ALT: 'Fintech Zaggle',
  },
  BEST_EMPLOYEE_ENGAGEMENT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/new/zaggle-home-news-three.webp',
    ALT: 'Best Employee Engagement',
  },
  TESTIMONIAL_PIRELLI: {
    URL: 'https://cdn.zaggle.in/images/web/propel/landing/webp/testimonial-pirelli.webp', // png
    ALT: 'Client Testinomial | Pirelli, Client Testinomial | Pirelli Tyres.',
  },
  TESTIMONIAL_AUROBINDO: {
    URL: 'https://cdn.zaggle.in/images/web/save/landing/webp/testi-aurobindo.webp', // png
    ALT: 'Zaggle Propel aurobindo',
  },
  MONEYFY_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/webp/moneyfy-logo.webp', // png
    ALT: 'Moneyfy Logo',
  },
  MONEYFY_TOP_RATED_FUNDS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/top-rated-funds.png',
    ALT: 'Moneyfy top rated funds',
  },
  MONEYFY_TAX_SAVER_FUNDS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/tax-saver-funds.png',
    ALT: 'Moneyfy tax saver funds',
  },
  MONEYFY_INVEST_IN_GOLD: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/invest-in-gold.png',
    ALT: 'Moneyfy invest in gold',
  },
  MONEYFY_STARTING_SIP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/starting-sip.png',
    ALT: 'Moneyfy starting sip',
  },
  THANK_YOU_BG: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/thank-you.webp', // jpg
    ALT: 'Thank You Page Background Image',
  },
  CALL_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/call.png',
    ALT: 'Call Icon for Thank You Page',
  },
  MAIL_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/email.png',
    ALT: 'Mail Icon for Thank You Page',
  },
  // Moneyfy Campaign Landing Pages
  ZAGGLE_WHITE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/zaggle-white-logo.png',
    ALT: 'Zaggle White Logo',
  },
  MONEYFY_WHITE_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/white-bg-moneyfy-logo.png',
    ALT: 'Moneyfy White Logo',
  },
  INSURE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/insure.png',
    ALT: 'Moneyfy Secure Landing Page Logo',
  },
  PIGGY_BANK_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/webp/piggy-bank-logo.webp', // png
    ALT: 'Moneyfy Grow & Secure Landing Pages Logos',
  },
  ATM_WITHDRAWAL_FACILITY: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/atm-withdraw.png',
    ALT: 'ATM Withdrawal Facility Payroll Card',
  },
  INVEST: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/invest.png',
    ALT: 'Moneyfy Secure Landing Page Logo',
  },
  GET_LOAN: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/get-loan.png',
    ALT: 'Moneyfy Secure Landing Page Logo',
  },
  TOP_RATED_FUNDS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/top-rated.png',
    ALT: 'Moneyfy Grow Landing Page Logo',
  },
  TAX_SAVER_FUNDS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/tax-saver.png',
    ALT: 'Moneyfy Grow Landing Page Logo',
  },
  SIP_500: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/moneyfy/sip-500.png',
    ALT: 'Moneyfy Grow Landing Page Logo',
  },
  // Manipalcigna Images
  MANIPAL_BRAND_LOGO: {
    URL: 'https://cdn.zaggle.in/images/web/propel/client/manipal/manipalcigna-brand-store-logo.png',
    ALT: 'Manipalcigna Brand Logo',
  },
  PROPEL_CAMPAGIN_CORP_GIFTING: 'https://cdn.zaggle.in/images/web/zaggle/client/propel/diwali/diwali-gifting-video.mp4',
  PROPEL_CORP_GIFT_LAMP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/client/propel/diwali/propel-diwali-lamp.png',
    ALT: 'Propel Corporate Gifting',
  },
  PROPEL_CORPORATE_GIFT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/client/propel/diwali/propel-corp-campaign.png',
    ALT: 'Propel Corporate Gifting',
  },
  // New image changes
  NEW_ZAGGLE_CLIENTS: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/client/propel/diwali/propel-corp-campaign.png',
    ALT: 'Zaggle clients',
  },
  ZAGGLE_CARD_FRONT_NSDL: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/nsdl-card-front.webp', // png
    ALT: 'Zaggle Login card',
  },
  ZAGGLE_CARD_BACK_NSDL: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/nsdl-card-back.webp',
    ALT: 'Zaggle Login card',
  },
  XPNS_POPUP: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/XPNS_popup.webp',
    ALT: 'XPNS Launching Popup',
  },
  DRIVER_SALARY_IMAGE: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/webp/driver-salary.svg',
    ALT: 'Driver Salary Image',
  },
  ZAGGLE_CARD_FRONT_YSC: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/zaggle-induscard-front.webp',
    ALT: 'Zaggle Login Card',
  },
  ZAGGLE_CARD_BACK_YSC: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/webp/zaggle-induscard-back.webp',
    ALT: 'Zaggle Login Card',
  },
  ZAGGLE_RUPAY_KUBER_CARD_FRONT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/kuber_card_rupay_front.png',
    ALT: 'Zaggle Login Card',
  },
  ZAGGLE_VISA_KUBER_CARD_FRONT: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/kuber_card_visa_front.png',
    ALT: 'Zaggle Login Card',
  },
  ZAGGLE_KUBER_CARD_BACK: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/kuber_card_back.png',
    ALT: 'Zaggle Login Card',
  },
  ZAGGLE_CARD_FRONT_IDFC: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/idfc_card_front.png',
    ALT: 'Zaggle Login Card',
  },
  ZAGGLE_CARD_BACK_IDFC: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/landing/idfc_card_back.png',
    ALT: 'Zaggle Login Card',
  },
  LYRA_GIFT_CARD: {
    URL: 'https://cdn.zaggle.in/images/web/propel/landing/lyra-voucher-card.jpeg',
    ALT: 'Lyra Gift Card',
  },
  LYRA_PAYMENT_PROCESSING: {
    URL: 'https://cdn.zaggle.in/images/web/propel/landing/payment-processing.gif',
    ALT: 'Payment Processing',
  },
  LYRA_PAYMENT_SUCCESS: {
    URL: 'https://cdn.zaggle.in/images/web/propel/landing/payment-success.png',
    ALT: 'Payment Successfull',
  },
  LYRA_PAYMENT_FAILED: {
    URL: 'https://cdn.zaggle.in/images/web/propel/landing/payment-failed.png',
    ALT: 'Payment Failed',
  },

  TWITTER_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/x-twitter-icon.svg',
    ALT: 'Twitter Icon',
  },
  WHATSAPP_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/whatsapp-icon.svg',
    ALT: 'WhatsApp Icon',
  },
  YOUTUBE_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/youtube-icon.svg',
    ALT: 'YouTube Icon',
  },
  INSTAGRAM_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/instagram-icon.svg',
    ALT: 'Instagram Icon',
  },
  FACEBOOK_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/fb-icon.svg',
    ALT: 'Facebook Icon',
  },
  LINKEDIN_ICON: {
    URL: 'https://cdn.zaggle.in/images/web/zaggle/svg/linkedin-icon.svg',
    ALT: 'LinkedIn Icon',
  },
  ZAGGLE_PLAY_STORE: {
    URL: 'https://cdn.zaggle.in/images/web/edge/webp/Google-Play-Icon.webp',
    ALT: 'Zaggle - Finance & Business @ App Store',
  },
  ZAGGLE_APP_STORE: {
    URL: 'https://cdn.zaggle.in/images/web/edge/webp/App-Store-Icon.webp',
    ALT: 'Zaggle - Finance & Business @ Play Store',
  },

};

export default AWS_STATIC_FILES;



// WEBPACK FOOTER //
// client/config/endPoints/imagesEndPoints.js